<div class="tab-pane" id="quotes" role="tabpanel">

    <div class="row mb-4">
        <div class="col-lg-12 col-md-12 form-inline">
            <label name="searchQuotes" id="searchQuotesID" class="label_cls mr-2">Search Quotes</label>
            <div class="input-group search_policies mousePointer">
                <span class="p-input-icon-right">
                    <i class="pi pi-search"></i>
                    <input autocomplete="off" type="text" class="filter_search_wid global_search_wid" pInputText name="searchQuotesFilter" 
                    style="height: 2.5rem;" id="searchQuotesFilterID" placeholder="Reference Number, Named Insured, Jobsite Address, Quote Name"  
                    (input)="quoteGrid.filterGlobal($event.target.value, 'contains')"/>
                </span>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-12">
            <span name="Quotes60Days" id="Quotes60DaysID" class="heading_search_policies">
                Quotes <small>(past 60 days)</small>
            </span>
            <span class="float-right text-right">
                <span name="Export" id="ExportID" class="search_policies_link mousePointer " (click)="exportExcel(quoteGrid)">
                    <i name="ExportIcon" id="ExportIconID" class="fa fa-file-excel-o excel_icon_cls mr-1" style="font-size: 16px;"
                        aria-hidden="true"></i> 
                        Export </span>
                <span class="center_line"> | </span>
                <a name="viewAll" id="viewAllID" class="search_policies_link mousePointer" style="color:#007bff" (click)="ViewAll()">{{viewALL?"View Less":"View All"}}</a>
            </span>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12 mt-0 mb-5 ">

            <p-table name="quoteGrid" id="quoteGridID" #quoteGrid [globalFilterFields]="['referenceNumber','jobSiteAddress','nameInsured','quoteName']"  class="policySearch gen-paginator-override" [value]="quotesList"  [style]="{width:'100%'}" 
            [rows]="!viewALL?10:null" [paginator]="!viewALL?true:false" columnResizeMode="expand"  pageLinks="{{!viewALL?8:null}}" [resizableColumns]="true"   styleClass="p-datatable-gridlines">
                <ng-template pTemplate="header">
                    <tr class="mousePointer">
                        <th class="mousePointer" width="180px" pResizableColumn pSortableColumn="referenceNumber">Reference Number<p-sortIcon
                                field="referenceNumber"></p-sortIcon>
                                <p-columnFilter type="text" field="referenceNumber" display="menu"></p-columnFilter>
                        </th>
                        <th width="160px" pResizableColumn pSortableColumn="jobSiteAddress">Jobsite Address<p-sortIcon
                                field="jobSiteAddress"></p-sortIcon>
                                <p-columnFilter type="text" field="jobSiteAddress" display="menu"></p-columnFilter>
                        </th>
                        <th pResizableColumn pSortableColumn="nameInsured">Name Insured<p-sortIcon
                                field="nameInsured"></p-sortIcon>
                                <p-columnFilter type="text" field="nameInsured" display="menu"></p-columnFilter>
                        </th>
                        <th pResizableColumn pSortableColumn="quoteName">Quote Name<p-sortIcon field="quoteName">
                            </p-sortIcon>
                            <p-columnFilter type="text" field="quoteName" display="menu"></p-columnFilter>
                        </th>
                        <th pResizableColumn pSortableColumn="effectiveDate">Effective Date<p-sortIcon
                                field="date"></p-sortIcon>
                                <p-columnFilter type="text" field="effectiveDate" display="menu"></p-columnFilter>
                        </th>
                        <th pResizableColumn pSortableColumn="expireDate">Expired Date<p-sortIcon
                            field="date"></p-sortIcon>
                            <p-columnFilter type="text" field="expireDate" display="menu"></p-columnFilter>
                        </th>
                        <th class="" width="140px" pResizableColumn>&nbsp;</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-quotes>
                    <tr>
                        <td class="mousePointer" style="color: #007bff;"><a (click)="clickReferenceNumber(quotes)">{{quotes?.referenceNumber}}</a></td>
                        <td>{{quotes?.jobSiteAddress}}</td>
                        <td>{{quotes?.nameInsured}}</td>
                        <td>{{quotes?.quoteName}}</td>
                        <td>{{quotes?.effectiveDate | date : 'MM/dd/yyyy'}}</td>
                        <td>{{quotes?.expireDate | date : 'MM/dd/yyyy'}}</td>
                        <td class="text-center ">
                            <span class="mousePointer" style="display: block; justify-content: center; text-transform: uppercase;">
                                <span [ngClass]="getColorCode(quotes?.status)" (click)="clickReferenceNumber(quotes)">Continue Quote</span>
                            </span>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7">No records found.</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>

<app-cancel-policy-popup [policyDetails]="currentPolicy" *ngIf="showCancelPopup" (popupEvent)="popUpClose($event)"></app-cancel-policy-popup>

